import React from 'react';
import Sidebar from './Sidebar';
import { useT, LangToggle } from '../lib/i18n';
import SyncButton from './SyncButton';

/**
 * Outer shell for every page — Perfy structure with Calum colours.
 * Sidebar mount + slate-50 background + sticky topbar (breadcrumb, freshness,
 * LightSpeed sync button, NL/FR toggle) + soft accent wash.
 */
const ACCENT_WASH = {
  gold: 'from-[#cf9a40]/10 via-white to-transparent',
  green: 'from-[#114817]/10 via-white to-transparent',
  mint: 'from-[#8bd4be]/20 via-white to-transparent',
};

export default function PageShell({ section = 'Calum', page, accent = 'gold', freshness, children }) {
  const t = useT();
  const wash = ACCENT_WASH[accent] || ACCENT_WASH.gold;
  return (
    <Sidebar>
      <main className="min-h-screen bg-slate-50">
        <div className="sticky top-0 z-20 border-b border-slate-200 bg-white/90 backdrop-blur print:hidden">
          <div className="max-w-[1500px] mx-auto px-4 md:px-6 lg:px-8 h-14 flex items-center justify-between gap-3">
            <div className="flex items-center gap-2 text-sm pl-10 md:pl-0 min-w-0">
              <span className="font-semibold text-[#114817] shrink-0" style={{ fontFamily: 'Outfit, Inter, sans-serif' }}>{section}</span>
              {page && <><span className="text-slate-300">/</span><span className="text-slate-600 truncate">{t(page)}</span></>}
            </div>
            <div className="flex items-center gap-3 shrink-0">
              {freshness && <div className="hidden sm:block text-[11px] text-slate-400 truncate max-w-[40vw]">{freshness}</div>}
              <SyncButton />
              <LangToggle />
            </div>
          </div>
        </div>
        <div className={`bg-gradient-to-b ${wash}`}>
          <div className="max-w-[1500px] mx-auto px-4 md:px-6 lg:px-8 pt-6 pb-10">
            {children}
          </div>
        </div>
      </main>
    </Sidebar>
  );
}
